import React from 'react'
import Styles from '../../../Css/View360/View360.module.css'
import View360CommonStyle from '../../../Css/View360/View360Common.module.css'
import Switch from '@mui/material/Switch';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { checkIsV2 } from '../../../utils/getAppVersion';
const theme = createTheme({
    components: {
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    color: "#ccc"
                },
                colorPrimary: {
                    "&.Mui-checked": {
                        color: "#f2ff00"
                    }
                },
                track: {
                    // Controls default (unchecked) color for the track
                    opacity: 1,
                    backgroundColor: "#fff",
                    ".Mui-checked.Mui-checked + &": {
                        opacity: 1,
                        backgroundColor: "#00000033"
                    }
                }
            }
        }
    }
});
const HotspotToggleHandler = ({handleHotSpotViewToggle, toggleHotspotView, isSpanish}) => {
    const isV2 = checkIsV2()  
    return (
        <div 
        className={'relative pl-2 py-[9px] rounded-[8px] bottom-0 bg-white-default border border-gray-200 h-[40px] z-[90] flex items-center justify-center'} >
            
            <span className='text-[14px] right-0 font-inter font-medium' style={{color:'black'}}>
            {isSpanish ? 'Puntos de acceso' : 'Hotspots'}
            </span>
            <ThemeProvider theme={theme}>
                <span className=''>
                <Switch
                    onChange={handleHotSpotViewToggle}
                    checked={toggleHotspotView}
                    
                    sx={{
                        '& .MuiSwitch-thumb': {
                            backgroundColor: toggleHotspotView ? (isV2 ? 'rgba(70, 0, 242, 1)' : '#4600F2') : (isV2 ? '#fff' : '#B1B1B1') // Change thumb color when switch is on
                        },
                        '& .MuiSwitch-track': {
                            backgroundColor: isV2 ? 'rgba(0, 0, 0, 0.12)' : '#707070' // Change track color
                        },
                        '& .css-19ock7p-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                            backgroundColor: '#FFFFFF33'
                        },
                        // Added styles for disabled state
                        '&.Mui-disabled': {
                            '& .MuiSwitch-thumb': {
                                backgroundColor: '#B1B1B1'
                            },
                            '& .MuiSwitch-track': {
                                opacity: 0.5
                            }
                        }

                    }}
                    className={[Styles["customSwitchTrack"]]}
                    />
                    </span>
            </ThemeProvider>    

        </div>
    )
}

export default HotspotToggleHandler